<template>
    <v-app-bar v-if="$route.name !== 'Login'" color="#111111" flat app>
        <v-container fluid>
            <v-row>
                <v-col @click="goToOption(item)" cols="3" v-for="item in items" :key="item.name" link>
                    <v-icon small :color="(item.name === itemSelected)? '#00f553' : '#FFFFFF'">{{ item.icon }}</v-icon>
                    <p class="mb-n1" :style="`font-size: 14px; color: ${(item.name === itemSelected)? '#00f553' : '#FFFFFF'}`">{{ item.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </v-app-bar>
</template>

<script>
    import { mapMutations } from 'vuex';
    export default {
        name: "AppBar",
        data() {
            return {
                itemSelected: 'Dashboard',
                items: [
                    { name: 'Dashboard', icon: 'fa-tachometer-alt', path: '/dashboard' },
                    { name: 'Users', icon: 'fa-users', path: '/users' },
                    { name: 'Trades', icon: 'fa-stream', path: '/trades' },
                    { name: 'Help', icon: 'fa-life-ring', path: '/help-desk' },
                    //{ name: 'Logout', icon: 'fa-power-off', path: '/' },
                ],
            };
        },
        methods: {
            ...mapMutations(['logout']),
            goToOption(item) {
                if(item.name === 'Logout')
                    this.logout();
                this.itemSelected = item.name;
                this.$router.push(item.path);
            },
        }
    }
</script>

<style scoped>

</style>
